/**
 * Order Entry - Panel Enum
 * This enumeration contains identifiers for all panels and screens the comprize the order entry interface,
 */
export enum OENPanel {
  SCREEN_ORDER_ENTRY,
  PANEL_CLIENT,
  PANEL_FINANCIALS,
  PANEL_MORE,
  PANEL_ACTIONS,
  PANEL_NOTIFICATIONS,
  PANEL_ALGO,
  PANEL_OBO,
}
